var App = App || {};

App.Accordion = (function ($) {
    "use strict";

    var $accordion, $window;

    function init() {
        var searchParams, collapseId;


        $accordion = $('.accordion');
        $window = $(".window");

        location.hash && $(location.hash + '.collapse').collapse('show');

        $accordion.on('shown.bs.collapse', function (e) {
            var $target = $(e.target);
            if ($target.offset().top < $window.scrollTop()) {
                $('html,body').stop().animate({ scrollTop: $target.offset().top - 50 }, 300);
            }
        });

        if (typeof window.location.search === "string" && window.location.search.includes("Accordion")) {
            searchParams = new URLSearchParams(window.location.search);

            if (searchParams.has("Accordion")) {
                collapseId = searchParams.get("Accordion");

                if ($("body #" + collapseId).length > 0) {
                    $("body #" + collapseId).siblings(".card-header").find("button").click();

                    if ($("body #" + collapseId).siblings(".card-header").offset().top > 100) {
                        window.setTimeout(function () {
                            $("html, body").animate({ scrollTop: $("body #" + collapseId).siblings(".card-header").offset().top - 100 + "px" });
                        }, 1000);
                    }
                }
            }
        }
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.Accordion.init();
});